import React from "react";
import {
    formatMarginLevel,
    getMarginLevelStatus,
} from "./marginLevelUtils";

export { formatMarginLevel, getMarginLevelStatus } from "./marginLevelUtils";

export default function MarginLevelIndicator({
    ml,
    hasDebt = true,
    thresholds,
    onInfoClick,
    showTooltip = true,
    variant = "inline",
}) {
    const status = getMarginLevelStatus(ml, thresholds, { hasDebt });
    const display = hasDebt ? formatMarginLevel(ml) : "Safe";
    const isWallet = variant === "wallet";

    const infoControl = onInfoClick ? (
        <button
            type="button"
            className="agce-margin-level-info-btn"
            onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onInfoClick();
            }}
            aria-label="View margin risk details"
        >
            <i className="ri-information-line agce-margin-level-info-icon" aria-hidden />
        </button>
    ) : showTooltip && hasDebt && ml != null && Number.isFinite(ml) ? (
        <span className="trade-info-tooltip-wrapper agce-margin-level-info">
            <i className="ri-information-line agce-margin-level-info-icon" aria-hidden />
            <div className="trade-info-tooltip agce-margin-level-tooltip">
                <div className="tooltip-item">
                    <strong className={`agce-margin-level-status-label agce-margin-level--${status.key}`}>{status.label}</strong>
                    <span className="agce-margin-level-tooltip-value"> · {display}</span>
                </div>
                <div className="tooltip-item">{status.description}</div>
            </div>
        </span>
    ) : null;

    const valueEl = (
        <span
            className={`agce-margin-level-value agce-margin-level--${status.key}`}
            style={{ color: status.color }}
        >
            {display}
        </span>
    );

    if (isWallet) {
        return (
            <span className={`margin-level-wallet-badge agce-margin-level-indicator agce-margin-level-indicator--wallet agce-margin-level-wallet--${status.key}`}>
                {valueEl}
                {infoControl}
            </span>
        );
    }

    return (
        <span className={`agce-margin-level-indicator agce-margin-level-indicator--${status.key}`}>
            {valueEl}
            {infoControl}
        </span>
    );
}
